import React from 'react';
import { Button } from '@mui/material';
import { PaymentsCard, PaymentsContainer, PaymentsWrapper } from './Payments.styled';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../../config/routeConstants';
import {useTranslation} from 'react-i18next';

const PaymentFailure = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate(`/${RoutePaths.Payments}`);
  };

  return (
    <PaymentsContainer>
      <PaymentsWrapper>
        <PaymentsCard>
          <h1>{t('paymentFailure.title')}</h1>
          <p>{t('paymentFailure.errorMessage')}</p>
          <p>{t('paymentFailure.contactSupport')}</p>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleRetry}
            sx={{ mt: 2, py: 1.5 }}
          >
            {t('paymentFailure.tryAgain')}
          </Button>
        </PaymentsCard>
      </PaymentsWrapper>
    </PaymentsContainer>
  );
};

export default PaymentFailure;
